import { gql } from '@apollo/client'

export const FIND_ALL_TESTIMONIALS = gql`
  query findAllTestimonial($query: TestimonialQueryInput = {}) {
    findAllTestimonial(query: $query) {
      count
      items {
        id
        title
        description
        textFeedback {
          id
          shortFeedback
          fullFeedback
          order
          student {
            avatar
            fullName
            score
          }
          getStudentAvatar {
            photo
          }
        }
      }
    }
  }
`

export const CREATE_TESTIMONIAL = gql`
  mutation createTestimonial($createTestimonialInput: CreateTestimonialInput!) {
    createTestimonial(createTestimonialInput: $createTestimonialInput) {
      id
      title
      description
      textFeedback {
        id
        shortFeedback
        fullFeedback
        order
        student {
          avatar
          fullName
          score
        }
        getStudentAvatar {
          photo
        }
      }
    }
  }
`

export const UPDATE_TESTIMONIAL = gql`
  mutation updateTestimonial($updateTestimonialInputFieldName: UpdateTestimonialInput!) {
    updateTestimonial(updateTestimonialInputFieldName: $updateTestimonialInputFieldName) {
      id
      title
      description
    }
  }
`
